import React from "react";
import "./Food.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Hungry from "../../assets/img/projects/Food delivery.png";
import { Link } from "react-router-dom";
function Food() {
  return (
    <div className="food">
      <Col xs={40} md={30}>
        <Row className="justify-content-center mb-5 mt-3 mr-0 ">
          <Image className="" alt="profile" src={Hungry} fluid />
        </Row>
      </Col>
      <Link to="/">
        <span className="button">BACK</span>
      </Link>
    </div>
  );
}

export default Food;
